// Circular text with manual positioning control
document.addEventListener('DOMContentLoaded', function() {
  const circularTexts = document.querySelectorAll('.circular-text');
  
  circularTexts.forEach(function(container) {
    const text = container.getAttribute('data-text');
    if (!text) return;
    
    container.innerHTML = '';
    
    const letters = Array.from(text);
    const totalLetters = letters.length;
    
    // Manual offset: adjust this number to rotate starting position
    // -90 = starts at left, 0 = starts at top, 90 = starts at right
    const manualOffsetDegrees = -90; // Adjust until "PERFORMATIVE" is at top
    
    letters.forEach(function(letter, index) {
      const span = document.createElement('span');
      span.textContent = letter;
      
      // Calculate rotation with manual offset
      const baseRotation = (360 / totalLetters) * index;
      const rotationDeg = baseRotation + manualOffsetDegrees;
      
      span.style.transform = 'rotate(' + rotationDeg + 'deg)';
      
      container.appendChild(span);
    });
  });
});